import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  Spinner,
  IconButton,
} from "@material-tailwind/react";

import {
  IoMdArrowDropleftCircle,
  IoMdArrowDroprightCircle,
} from "react-icons/io";

import ReportCard from "components/reportCard";

import ReportDetails from "../ReportDetails";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getAllReportsListApi, updateReportDataApi } from "api/gestionStock";

function ByrotInvoces({ selected, filterInputs, accessList }) {
  const [openReportDetails, setOpenReportDetails] = useState(false);

  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [reportsList, setReportsList] = useState([]);
  const [isLoading, setIsLoading] = useState([]);

  const [active, setActive] = useState(1);
  const [currentPagination, setCurrentPagination] = useState(1);

  const [numberOfPages, setNumberOfPages] = useState(0);
  const [numberOfPaginations, setNumberOfPaginations] = useState(0);
  const [numberOfReports, setNumberOfReports] = useState(0);

  const [selectedReportId, setSelectedReportId] = useState({})

  useEffect(() => {
    getInitialData(1, currentYear, filterInputs.MP, filterInputs.clientName, "V", "V", "V", "", filterInputs.etatMagasin);

    setActive(1);
    setCurrentPagination(1)
  }, [selected, filterInputs]);

  const getInitialData = async (
    page,
    currentYear,
    MP,
    clientName,
    etatMagasin,
    EtatBonLivraison,
    EtatFacturation,
    EtatMagasinierTwo,
    EtatValidationB
  ) => {
    try {
      setIsLoading(true);
      const reportsData = await getAllReportsListApi(
        page,
        currentYear,
        MP,
        clientName,
        etatMagasin,
        EtatBonLivraison,
        EtatFacturation,
        EtatMagasinierTwo,
        EtatValidationB
      );
      setReportsList(reportsData);

      setNumberOfPages(reportsData.pagination.numberOfPages);
      setNumberOfPaginations(reportsData.pagination.numberOfPaginations);
      setNumberOfReports(reportsData.pagination.numberOfClients);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenReportDetails = (id) => {
    if(accessList.Read) {
      setSelectedReportId(id)
      setOpenReportDetails(!openReportDetails);
    }
  };

  const handleValidateReport = (reportID) => {
    try {
      if(accessList.Validation) {
        withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Voulez-vous vraiment valider cette opération ?",
          confirmButtonText: "Valider",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            setIsLoading(true);
            const updatedObject = {
              EtatValidationB: "V",
            };
            await updateReportDataApi(reportID, updatedObject)
            // await updateFCreatedTApi(reportID)
            getInitialData(active, currentYear, filterInputs.MP, filterInputs.clientName, "V", "V", "V", "", filterInputs.etatMagasin);
            Swal.fire("Validée", "", "success");
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
    finally {
      setIsLoading(false);
    }
  }

  const handleCancelReport = (reportID) => {
    try {
      if(accessList.Validation) {
        withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Voulez-vous vraiment annuler cette opération ?",
          confirmButtonText: "Annuler",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            setIsLoading(true);
            const updatedObject = {
              EtatValidationB: "A",
            };
            await updateReportDataApi(reportID, updatedObject)
            // await updateFCreatedTApi(reportID)
            getInitialData(active, currentYear, filterInputs.MP, filterInputs.clientName, "V", "V", "V", "", filterInputs.etatMagasin);
            Swal.fire("Annulée", "", "success");
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
    finally {
      setIsLoading(false);
    }
  }

  const getItemProps = (index) => ({
    variant: active === index ? "filled" : "text",
    color: "gray",
    onClick: () => {
      getInitialData(index, currentYear, filterInputs.MP, filterInputs.clientName, "V", "V", "V", "", filterInputs.etatMagasin);
      setActive(index);
    },
  });

  const next = () => {
    if (currentPagination === numberOfPaginations) return;
    setCurrentPagination(currentPagination + 1);
  };

  const prev = () => {
    if (currentPagination === 1) return;
    setCurrentPagination(currentPagination - 1);
  };

  return (
    <>
      <div style={{ height: "40vh", overflowY: "scroll" }}>
        <Dialog
          size="xl"
          open={openReportDetails}
          handler={handleOpenReportDetails}
        >
          <DialogHeader>
            <p className="w-full text-center">Vente (s)</p>
          </DialogHeader>
          <DialogBody className="h-[80vh] overflow-scroll">
            <ReportDetails typeOf="BYROT" selectedReportId={selectedReportId} accessList={accessList} />
          </DialogBody>
        </Dialog>

        {isLoading ? (
            <div className="flex w-full items-center justify-center">
              <Spinner className="h-12 w-12" />
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-3 pb-2 pr-1 lg:grid-cols-2">
              {reportsList?.data.map((el) => (
                <ReportCard
                  key={el._id}
                  report={el}
                  documentNumber={el.RF}
                  status={el.EtatValidationB}
                  docTypes={Object.getOwnPropertyNames(el.Rapport)}
                  badges={
                    el.FacturationFinDeMois ? ["Facturation fin de mois"] : []
                  }
                  totals={[
                    {
                      label: "Total HT",
                      value: Object.keys(el.Rapport)
                        .map((category) =>
                          parseFloat(el.Rapport[category].TotaleHT).toFixed(2)
                        )
                        .join(" - "),
                    },
                    {
                      label: "TVA",
                      value: Object.keys(el.Rapport)
                        .map((category) =>
                          parseFloat(el.Rapport[category].TVA).toFixed(2)
                        )
                        .join(" - "),
                    },
                    {
                      label: "Total TTC",
                      value: Object.keys(el.Rapport)
                        .map((category) =>
                          parseFloat(el.Rapport[category].TTC).toFixed(2)
                        )
                        .join(" - "),
                      strong: true,
                    },
                  ]}
                  canUpdate={accessList.Validation}
                  onOpen={() => handleOpenReportDetails(el._id)}
                  onValidate={() => handleValidateReport(el._id)}
                  onCancel={() => handleCancelReport(el._id)}
                />
              ))}
            </div>
          )}
      </div>

      {!isLoading && numberOfReports != 0 && (
          <div className="mt-4 flex items-center gap-4">
            <Button
              variant="text"
              className="flex items-center gap-2"
              onClick={prev}
              disabled={currentPagination === 1}
            >
              <IoMdArrowDropleftCircle size={30} />
            </Button>
            <div className="flex items-center gap-2">
              {currentPagination !== numberOfPaginations
                ? // paginations row
                  Array.from({
                    length: numberOfPages > 5 ? 5 : numberOfPages,
                  }).map((el, index) => {
                    const pageNumber = index + 1 + (currentPagination - 1) * 5;
                    return (
                      <IconButton {...getItemProps(pageNumber)}>
                        {pageNumber}
                      </IconButton>
                    );
                  })
                : // last pagination row
                  Array.from({ length: numberOfPages % 5 }).map((el, index) => {
                    const pageNumber = index + 1 + (currentPagination - 1) * 5;
                    return (
                      <IconButton {...getItemProps(pageNumber)}>
                        {pageNumber}
                      </IconButton>
                    );
                  })}
            </div>
            <Button
              variant="text"
              className="flex items-center gap-2"
              onClick={next}
              disabled={
                currentPagination === numberOfPaginations ||
                numberOfPaginations === 0
              }
            >
              <IoMdArrowDroprightCircle size={30} />
            </Button>
          </div>
      )}
    </>
  );
}

export default ByrotInvoces;
